import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { FareManagementPage } from './finance/FareManagementPage';
import { CouponManagementPage } from './finance/CouponManagementPage';
import { PaymentMethodsPage } from './finance/PaymentMethodsPage';
import { FinancialReportsPage } from './finance/FinancialReportsPage';
import { FinanceOverviewPage } from './finance/FinanceOverviewPage';

export function FinancePage() {
  return (
    <Layout>
      <Routes>
        <Route index element={<FinanceOverviewPage />} />
        <Route path="fares" element={<FareManagementPage />} />
        <Route path="coupons" element={<CouponManagementPage />} />
        <Route path="payments" element={<PaymentMethodsPage />} />
        <Route path="reports" element={<FinancialReportsPage />} />
        <Route path="*" element={<Navigate to="/finance" replace />} />
      </Routes>
    </Layout>
  );
}
